import React from "react";
import styles from "./Location.mobile.module.scss";

const Location = ({ data, dictionary, lang }) => {
  if (data) {
    return (
      <>
        <div className={styles.location}>
          <h3>{data.title}</h3>
          <p className={styles.address}>{data.address}</p>
          <div className={styles.viewMap}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='14'
              height='14'
              viewBox='0 0 14 14'
              fill='none'
            >
              <g clip-path='url(#clip0_5818_49759)'>
                <path
                  d='M12.3616 3.08001C12.6656 2.16796 11.7979 1.30026 10.8859 1.60428L1.5706 4.70937C0.506951 5.06391 0.506949 6.56841 1.57059 6.92296L5.12143 8.10657C5.4698 8.22269 5.74317 8.49606 5.85929 8.84444L7.0429 12.3953C7.39745 13.4589 8.90195 13.4589 9.2565 12.3953L12.3616 3.08001Z'
                  fill='#2378E5'
                />
              </g>
              <defs>
                <clipPath id='clip0_5818_49759'>
                  <rect width='14' height='14' fill='white' />
                </clipPath>
              </defs>
            </svg>
            <a href={data.map_url} target='_blank'>
              {dictionary.viewMapText}
            </a>
          </div>
        </div>
      </>
    );
  }

  return null;
};

export default Location;
